import script from "./StatusText.vue?vue&type=script&setup=true&lang=js"
export * from "./StatusText.vue?vue&type=script&setup=true&lang=js"

import "./StatusText.vue?vue&type=style&index=0&id=4ac72cb4&lang=scss"

const __exports__ = script;

export default __exports__